/*
 * @Description: 支付通道
 * @Date: 2023-09-09 14:13:07
 */
// import { sleep } from '@/tools/timer';
import { OPEN_STATUS_MAPPING } from '@/common/constants/bank';
import { account } from '@/api/ajax';

const BaseBank = {
  openStatusKey: 'openStatus', // 开户字段
  cashOutTypeKey: 'cashOutType', // 提现方式字段
  /**
   * @description: 返回对应银行的开户状态文案
   * @param {object} row 当前行数据
   * @return {string} 对应银行银行开户状态文案
   */
  getBankOpenStatusLabel(row) {
    const { value, openStatusKey } = this;
    const field = row[value];
    if (!field) {
      console.error('无匹配银行数据');
      return '-';
    }
    if (field[openStatusKey] === void 0) {
      console.error('无银行开户状态字段');
      return '-';
    }
    return OPEN_STATUS_MAPPING[field[openStatusKey]].label;
  }
};

/*
  该mapping 在搜索条件的options中、列表展示字段、开通状态选项、银行相关字段展示中使用。收支平台=支付通道
  列表使用时，row中会有对应value(zbBank)的对象，
  例：
     https://lanhuapp.com/web/#/item/project/product?tid=bd3f2b58-50f5-4bec-9b00-6f9eaa1fa964&pid=9c72a26b-451a-4301-99a0-975ca38d69cb&versionId=9fff8b6b-065a-4440-b3ac-74418617930c&docId=17505054-ad28-42c9-9cff-8a8751a529af&docType=axure&image_id=17505054-ad28-42c9-9cff-8a8751a529af&pageId=0c38536fc4ba4956b25a704893eb5957&parentId=5eff4b86-f21f-47b6-b915-8e5a4b12d82e
     expand中支付通道展示字段、弹层内等字段。

     https://lanhuapp.com/web/#/item/project/product?tid=bd3f2b58-50f5-4bec-9b00-6f9eaa1fa964&pid=9c72a26b-451a-4301-99a0-975ca38d69cb&versionId=9fff8b6b-065a-4440-b3ac-74418617930c&docId=17505054-ad28-42c9-9cff-8a8751a529af&docType=axure&image_id=17505054-ad28-42c9-9cff-8a8751a529af&pageId=978ebc26c70948d0ab86b00ee4ead27c&parentId=5eff4b86-f21f-47b6-b915-8e5a4b12d82e
     table中的【众邦银行】【富友支付】都是遍历的BANK_MAPPING
      row: {
        id: 1,
        csoName: '从v地方企业名',
        zbBank: {
          -: 1,
          cashOutType: 2
        },
        fyBank: {
          openStatus: 1,
          cashOutType: 2
        }
      }

      {{ bank.getBankOpenStatusLabel(row) }}
*/

const bank = {
  namespaced: true,
  state: {
    banks: {},
    payMethod: []
  },
  mutations: {
    INIT_BANKS: (state, banks) => {
      state.banks = banks;
    },
    INIT_PAY_METHOD: (state, payMethod) => {
      state.payMethod = payMethod;
    }
  },
  actions: {
    async setBanks({ state, dispatch }) {
      if (!Object.values(state.banks).length) {
        await dispatch('getBanks');
      }
      if (!state.payMethod.length) {
        await dispatch('getPayMethod');
      }
    },

    // 获取支付通道
    async getBanks({ commit }) {
      try {
        const { pdata } = await account.queryByCode({
          dicCode: 'pay_passage_way'
        });
        commit(
          'INIT_BANKS',
          pdata.reduce((pre, cur, index) => {
            pre[cur.dicValue] = {
              id: index,
              label: cur.dicDescribe,
              value: cur.dicValue,
              status: cur.status, // 0关闭 1可用
              ...BaseBank,
              query: {
                openStatusKey: 'zbBankOpenStatus'
              },
              isDefault: +cur.isDefault
            };
            return pre;
          }, {})
        );
      } catch (error) {
        console.log(error);
      }
    },
    // 获取服务商付款方式
    async getPayMethod({ commit }) {
      try {
        const { pdata } = await account.queryByCode({
          dicCode: 'PAY_TYPE'
        });

        const payMethodArr = [
          // {
          //   label: '全部',
          //   value: null,
          //   status: 0
          // }
        ];
        pdata.forEach(item => {
          payMethodArr.push({
            label: item.dicDescribe,
            value: item.dicValue, //  1 线上支付 2 线下支付
            status: +item.status
          });
        });
        commit('INIT_PAY_METHOD', payMethodArr);
      } catch (error) {
        console.log(error);
      }
    }
  }
};

export default bank;
